/* eslint-disable no-plusplus */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, Input } from 'react-materialize';
import { ToastContainer } from 'react-toastify';
import Dialog from '../Dialog';
import Wrapper from './wrapper';

import { formatsInputFile } from '../../utils/imagesAccept'

const Card = props => {
  const {
    error,
    status,
    loader,
    resorted,
    readOnly,
    imagesList,
    descrGlosa,
    resortGlossa,
    glosaCount,
    handleTextOn,
    valueJustify,
    imagesPending,
    disabledImages,
    changeFileImage,
    deleteElementPedding
  } = props;

  const isGlosa = status === 'GLOSADO';
  const isRecursado = status === 'RECURSADO';

  const haveImagesList = !!imagesList.length;
  const haveImagesPending = !!imagesPending.length;
  const canSendImage = isGlosa && !disabledImages && !readOnly;
  const canAttach = status !== 'analise' && !readOnly;

  return (
    <div className="ProcedureGto__internal-card">
      {/** CONTEÚDO DE GLOSA */}
      {isGlosa && (
        <Fragment>
          <hr />
          <div className="reason">
            <label className="hat active">Motivo</label>
            <p>{descrGlosa}</p>
          </div>

          {!(readOnly || resorted) && (
            <div className="justification">
              <label className="hat active">Justificativa</label>
              <Input
                type="textarea"
                className={`${valueJustify ? 'active' : ''}`}
                onChange={handleTextOn}
                placeholder="Justificativa"
              />
            </div>
          )}
        </Fragment>
      )}

      {/** CONTEÚDO DE GLOSA */}
      {isRecursado && (
        <Fragment>
          <hr />
          <div className="reason">
            <label className="hat active">Motivo</label>
            <p>{descrGlosa}</p>
          </div>
          {valueJustify && (
            <div className="justification">
              <label className="hat active">Justificativa</label>
              <p>{valueJustify}</p>
            </div>
          )}
        </Fragment>
      )}

      {/** IMAGENS DO CONTEÚDO EM ANALISE */}
      {haveImagesList && (
        <Fragment>
          <hr />
          {imagesList.map((item, index) => (
            <div className="image" key={index}>
              <div className="box-image">
                <div className="attach">
                  <input className="link" type="file" accept="image/*" />
                  <div className="box--thumbnail">
                    <img crossorigin="anonymous" className="thumbnail" src={item} alt="Foto do procedimento" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Fragment>
      )}

      {/** PERMITE ANEXAR IMAGENS */}
      {canAttach && !resorted && !isRecursado && (
        <Fragment>
          <hr />
          <div className="image">
            <div className="box-image">
              <span>
                <div className="attach">
                  <span className="upImage" />
                  <div className="btn-upLoad">
                    <input
                      className="upload-input"
                      onChange={changeFileImage}
                      type="file"
                      accept={formatsInputFile}
                    />
                  </div>
                </div>
                <span className="nameImage">Anexar Imagem</span>
              </span>
            </div>
          </div>
        </Fragment>
      )}

      {/** IMAGENS RECÉM ADICIONADAS */}
      {haveImagesPending &&
        imagesPending.map((item, index) => (
          <div className="image" key={item.name}>
            <div className="box-image">
              <span>
                <div className="attach">
                  <div className="box--thumbnail">
                    <span
                      className="btn-close"
                      role="button"
                      tabIndex={0}
                      onClick={() => deleteElementPedding(index)}
                    />
                    <img crossorigin="anonymous" className="thumbnail" src={item.src} alt="thumbnail" />
                  </div>
                </div>
                <span className="nameImage">{item.name}</span>
              </span>
            </div>
          </div>
        ))}

      {canSendImage && !resorted && (
        <Button
          waves="light"
          className="sendToAnalysis"
          disabled={!valueJustify}
          onClick={async () => {
            loader({ isLoading: true });
            resortGlossa().finally(() => loader({ isLoading: false }));
          }}
        >
          <span>Solicitar Recurso</span>
        </Button>
      )}

      {error && <ToastContainer />}

      <Dialog
        ref={props.modalRef}
        header="Procedimento Atualizado"
        callback={() => props.redirect(glosaCount)}
        buttons={[
          {
            title: 'OK',
            callback: () => props.redirect(glosaCount)
          }
        ]}
      >
        <h5>Recurso enviado</h5>
        <p>Aguarde enquanto é feita a análise</p>
      </Dialog>
    </div>
  );
};

Card.propTypes = {
  error: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  loader: PropTypes.func.isRequired,
  imagesList: PropTypes.arrayOf(PropTypes.string).isRequired,
  descrGlosa: PropTypes.string,
  resortGlossa: PropTypes.func.isRequired,
  handleTextOn: PropTypes.func.isRequired,
  valueJustify: PropTypes.bool.isRequired,
  imagesPending: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabledImages: PropTypes.bool.isRequired,
  resorted: PropTypes.bool.isRequired,
  changeFileImage: PropTypes.func.isRequired,
  deleteElementPedding: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  glosaCount: PropTypes.number.isRequired
};

const mapStateToProps = ({ login: { user } }) => ({
  idCredenciado: user.codigo
});

export default connect(
  mapStateToProps,
  null
)(withRouter(Wrapper(Card)));